export const mobileModalPaddingSize = 10 // TODO: для обратной совместимости оставлю здесь, время появится заменить на src/common/components/presentational/index.tsx: 22
